// extracted by mini-css-extract-plugin
export default {"additional":"lE3Xh9hk","mobile":"AVjSrlfp","link":"MZfbvHgn"};